import React from 'react';
import PropTypes from 'prop-types';

import useGoodSelectedRegularDelivery from '@ecp/common/src/hooks/good/option/useGoodSelectedRegularDelivery';
import moTheme from '@ecp/common/src/style/theme/mo';
//import theme from '@ecp/common/src/style/theme/default';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';
import { useTheme } from 'styled-components';

const GoodSelectedRegularDelivery = ({ selectedRegularDelivery, hasTimeList }) => {
  const theme = useTheme();
  const { selectedAll, deliveryInfo, deliveryStateDateInfo } = useGoodSelectedRegularDelivery(
    selectedRegularDelivery,
    hasTimeList
  );

  return (
    <>
      {selectedAll && (
        <>
          <Spacing top={14} />
          <TextBox size={moTheme.font.size.$13}>{deliveryInfo}</TextBox>
          <Spacing top={4} />
          <TextBox size={moTheme.font.size.$13} weight={moTheme.font.weight.medium} color={theme.color.primary}>
            {deliveryStateDateInfo}
          </TextBox>
          <Spacing top={2} />
        </>
      )}
    </>
  );
};

export default GoodSelectedRegularDelivery;

GoodSelectedRegularDelivery.propTypes = {
  selectedRegularDelivery: PropTypes.shape({
    period: PropTypes.object,
    total: PropTypes.object,
    time: PropTypes.object,
    startDateTime: PropTypes.object,
  }),
  hasTimeList: PropTypes.bool,
};
